// src/layouts/Pages/PageHeader/CardHeaderColumns/items/createdAt.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { StarOutlined } from '@ant-design/icons';
import { parseDateToDisplay } from 'utils/helpers';
import translateX from 'utils/translateX';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const createdAtItem = record => {
  const createdAt =
    (record?._metadata?.audit?.createdAt &&
      parseDateToDisplay({ date: record._metadata.audit.createdAt })) ||
    (record?.createdAt && parseDateToDisplay({ date: record.createdAt }));

  return {
    key: 'createdAt',
    icon: <StarOutlined />,
    label: createdAt,
    tooltipText: translateX('creation_date'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export default createdAtItem;
